import App from 'App';

import QuestionAndAnsser from 'component/page/QuestionAndAnswer/QuestionAndAnsser';
import { QnaTicketTable } from 'component/page/QuestionAndAnswer/components/QnaTicketTable';
import ImportView from 'component/page/ExamManagement/ImportView';
import { createBrowserRouter } from 'react-router-dom';
import MasterSetting from 'component/page/MasterSetting/masterSetting';
import TestTemplateManagement from 'component/page/MasterSetting/ExamTemplate/TestTemplateManagement';
import EditTemplateView from 'component/page/ExamManagement/EditTemplateView';
import EditExamTemplate from 'component/page/MasterSetting/ExamTemplate/EditExamTemplate';
import LearningAsset from '../component/page/LearningAsset';
import LearningAssetManagement from '../component/page/LearningAsset/LearningAssetManagement';
import LearningAssetForm from '../component/page/LearningAsset/LearningAssetForm';
import TagManagement from '../component/page/LearningAsset/TagManagement';
import TagForm from '../component/page/LearningAsset/TagForm';
import CategoryManagement from '../component/page/LearningAsset/CategoryManagement';
import CategoryForm from '../component/page/LearningAsset/CategoryForm';
import ExerciseFormatManagement from 'component/page/MasterSetting/ExerciseFormatManagement/exerciseFormatManagement';
import SkillTypeManagement from 'component/page/MasterSetting/SkillType/ExerciseFormat/SkillTypeManagement';
import LearningBookManagement from '../component/page/LearningAsset/LearningBookManagement';
import LearningBookForm from '../component/page/LearningAsset/LearningBookForm';
import AssetTreeManagement from '../component/page/LearningAsset/AssetTreeManagement';
import TestBankTable from 'component/page/MasterSetting/TestBank/TestBankTable';
import QuestionAutoCode from '../component/page/QuestionBank/QuestionAutoCode';
import TheoryManagement from 'component/page/MasterSetting/Theory/TheoryManagement';
import LectureManagement from 'component/page/MasterSetting/Lecture/LectureManagement';
import GameManagement from 'component/page/MasterSetting/Game/GameManagement';
import ElectronicBook from '../component/page/ElectronicBook';
import BookManagementTable from '../component/page/ElectronicBook/BookManagementTable';
import BookAppendixTable from '../component/page/ElectronicBook/BookAppendixTable';
import ManageUser from '../component/page/ManageUser';
import UserManagement from '../component/page/ManageUser/UserManagement';
import ExamTableManagement from '../component/page/ExamManagement/ExamTableManagement';
import ExamManagement from '../component/page/ExamManagement/ExamManagement';
import GradeManagement from '../component/page/MasterSetting/GradeManagement';
import SubjectManagement from '../component/page/MasterSetting/SubjectManagement';
import { TicketStore } from '../component/page/MasterSetting/TicketStore/ticketStore';
import { FeedBack } from '../component/page/QuestionAndAnswer/FeedBack/feedback';
import { BookingSubManager } from 'component/page/BookingSub/bookingSub';
import ActiveCodeManagement from '../component/page/ElectronicBook/ActiveCodeManagement';
import PracticeManagement from '../component/page/PracticeManagement';
import QuestionBank from '../component/page/QuestionBank';
import QuestionManagement from '../component/page/QuestionBank/QuestionManagement';
import Dashboard from 'component/page/Dashboard/dashboard';
import DashboardLayout from 'component/page/Dashboard/layout';
import FeatureManagement from "../component/page/MasterSetting/FeatureManagement";
import UserSubscriptionManagement
  from "../component/page/MasterSetting/UserSubscriptionManagement/userSubscriptionManagement";
import PlanManagement from "../component/page/MasterSetting/PlanManagement";
import OrderManagement from "../component/page/MasterSetting/OrderManagement";

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/dashboard',
        element: <DashboardLayout />,
        children: [
          {
            path: '/dashboard',
            element: <Dashboard />,
          },
        ],
      },
      {
        path: '/electronic-book',
        element: <ElectronicBook />,
        children: [
          {
            path: '/electronic-book/book',
            element: <BookManagementTable />,
            children: [],
          },
          {
            path: '/electronic-book/book/:bookId',
            element: <BookAppendixTable />,
            children: [],
          },
          {
            path: '/electronic-book/active-code',
            element: <ActiveCodeManagement />,
            children: [],
          },
        ],
      },
      {
        path: '/master-setting',
        element: <MasterSetting />,
        children: [
          {
            path: '/master-setting/skill-type',
            element: <SkillTypeManagement />,
            children: [],
          },
          {
            path: '/master-setting/grade',
            element: <GradeManagement />,
            children: [],
          },
          {
            path: '/master-setting/subject',
            element: <SubjectManagement />,
            children: [],
          },
          {
            path: '/master-setting/exercise-format',
            element: <ExerciseFormatManagement />,
            children: [],
          },
          {
            path: '/master-setting/test-template',
            element: <TestTemplateManagement />,
            children: [],
          },
          {
            path: '/master-setting/edit-exam-template',
            element: <EditExamTemplate />,
            children: [],
          },
          {
            path: '/master-setting/edit-exam-template/:examTemplateId',
            element: <EditExamTemplate />,
            children: [],
          },
          {
            path: '/master-setting/ticket-store/:typeTicket',
            element: <TicketStore />,
            children: [],
          },
          {
            path: '/master-setting/test-bank/',
            element: <TestBankTable />,
            children: [],
          },
          {
            path: '/master-setting/theory/',
            element: <TheoryManagement />,
            children: [],
          },
          {
            path: '/master-setting/lecture/',
            element: <LectureManagement />,
            children: [],
          },
          {
            path: '/master-setting/game/',
            element: <GameManagement />,
            children: [],
          },
          {
            path: '/master-setting/feature/',
            element: <FeatureManagement />,
            children: [],
          },
          {
            path: '/master-setting/plan/',
            element: <PlanManagement />,
            children: [],
          },
          {
            path: '/master-setting/order/',
            element: <OrderManagement />,
            children: [],
          },
          {
            path: '/master-setting/user-subscription/',
            element: <UserSubscriptionManagement />,
            children: [],
          },
        ],
      },
      {
        path: '/exam-management',
        element: <ExamManagement />,
        children: [
          {
            path: '/exam-management/import',
            element: <ImportView />,
          },
          {
            path: '/exam-management/subject/:subjectId/exams/preview-generate-exam',
            element: <EditTemplateView />,
          },
          {
            path: '/exam-management/subject/:subjectId/exams/:examId',
            element: <EditTemplateView />,
          },
          {
            path: '/exam-management/subject/:subjectId/exams',
            element: <ExamTableManagement />,
          },
        ],
      },
      {
        path: '/practice-management',
        element: <PracticeManagement />,
        children: [
          {
            path: '/practice-management/import',
            element: <ImportView type={'practice'} />,
          },
          {
            path: '/practice-management/subject/:subjectId/practices/:examId',
            element: <EditTemplateView type={'practice'} />,
          },
          {
            path: '/practice-management/subject/:subjectId/practices',
            element: <ExamTableManagement type={'practice'} />,
          },
        ],
      },
      {
        path: '/user-management',
        element: <ManageUser />,
        children: [
          {
            path: '/user-management/user',
            element: <UserManagement />,
          },
        ],
      },
      {
        path: '/qna-tickets',
        element: <QuestionAndAnsser />,
        children: [
          {
            path: '/qna-tickets/tickets/:subjectId',
            element: <QnaTicketTable />,
          },
          {
            path: '/qna-tickets/feebacks',
            element: <FeedBack />,
          },
          {
            path: '/qna-tickets/booking-sub',
            element: <BookingSubManager />,
          },
        ],
      },
      {
        path: '/learning-assets',
        element: <LearningAsset />,
        children: [
          {
            path: '/learning-assets/',
            element: <LearningAssetManagement />,
          },
          {
            path: '/learning-assets/create',
            element: <LearningAssetForm />,
          },
          {
            path: '/learning-assets/update/:id',
            element: <LearningAssetForm />,
          },
          {
            path: '/learning-assets/asset-tree',
            element: <AssetTreeManagement />,
          },
          {
            path: '/learning-assets/learning-books',
            element: <LearningBookManagement />,
          },
          {
            path: '/learning-assets/learning-books/create',
            element: <LearningBookForm />,
          },
          {
            path: '/learning-assets/learning-books/update/:id',
            element: <LearningBookForm />,
          },
          {
            path: '/learning-assets/tags',
            element: <TagManagement />,
          },
          {
            path: '/learning-assets/tags/create',
            element: <TagForm />,
          },
          {
            path: '/learning-assets/tags/update/:id',
            element: <TagForm />,
          },
          {
            path: '/learning-assets/categories',
            element: <CategoryManagement />,
          },
          {
            path: '/learning-assets/categories/create',
            element: <CategoryForm />,
          },
          {
            path: '/learning-assets/categories/update/:id',
            element: <CategoryForm />,
          },
        ],
      },
      {
        path: '/question-bank',
        element: <QuestionBank />,
        children: [
          {
            path: '/question-bank/question-management',
            element: <QuestionManagement />,
          },
          {
            path: '/question-bank/question-auto-codes',
            element: <QuestionAutoCode />,
          },
        ],
      },
    ],
  },
]);

export default router;
